import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { useForm } from "../../../../hooks";
import { addStartupValoration } from "../../../helpers/startupValoration";
import { DateInput } from "../../DateInput";
import { toEnglishDate } from "../../../../helpers/dateFormat";
import { NumberInput } from "../../NumberInput";

export const AddStartupValoration = ({ startupList }) => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const [isWaiting, setIsWaiting] = useState(false);
  const [startupId, setStartupId] = useState("");
  const startupNameList = startupList.map((a) => a.name);
  const date = new Date();
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const actualDate = date.toLocaleDateString("es-ES", options);
  const [formValues, handleInputChange, reset] = useForm({
    startupId: "",
    participationValuation: "",
    valuationDate: toEnglishDate(actualDate),
    startupName: startupNameList[0],
  });

  const { participationValuation, valuationDate, startupName } = formValues;

  const handleConfirm = async (e) => {
    e.preventDefault();
    setIsWaiting(true);
    addStartupValoration(
      { ...formValues, startupId },
      t("valorationStartup.successMsg"),
      t("valorationStartup.errorMsg"),
      navigate
    );
    setIsWaiting(false);
    reset();
  };
  const handleCancel = () => {
    reset();
    navigate("/startup");
  };

  useEffect(() => {
    const findSelectedStatup = startupList.find(
      (startup) => startup.name === startupName
    );
    if (findSelectedStatup) {
      setStartupId(findSelectedStatup.id);
    }
  }, [startupName, startupList]);

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="primary" variant="h5">
          {t("valorationStartup.titlePage")}
        </Typography>
      </Stack>
      <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

      <form onSubmit={handleConfirm}>
        <Stack minHeight="calc(100vh - 290px)" gap={2}>
          <Stack width="100%" padding="0 5px">
            <Typography variant="overline" color="secondary">
              {t("valorationStartup.startupName")}
            </Typography>
            <Autocomplete
              disablePortal
              options={startupNameList}
              size="small"
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="startupName" />
              )}
              value={startupName}
              onSelect={handleInputChange}
              required
            />
          </Stack>

          <Stack direction="row" width="100%" gap={2}>
            <DateInput
              name={valuationDate}
              title="valuationDate"
              handleInputChange={handleInputChange}
              required={true}
            />
            <NumberInput
              name={participationValuation}
              title="participationValuation"
              handleInputChange={handleInputChange}
              required={true}
            />
          </Stack>
        </Stack>

        <Stack direction="row" justifyContent="end" gap={2} marginTop={3}>
          <Button
            sx={{ width: "140px" }}
            color="secondary"
            onClick={handleCancel}
            variant="outlined"
          >
            {t("myprofile.cancelButton")}
          </Button>
          <Button
            disabled={isWaiting}
            sx={{ width: "140px" }}
            type="submit"
            variant="contained"
          >
            {t("myprofile.confirmButton")}
          </Button>
        </Stack>
      </form>
    </>
  );
};
